const homeTexts = {
  fr: {
    subtitle: "musicien compositeur arrangeur",
    paragraph: `Pianiste sur scène et compositeur-réalisateur en studio, Ben Bridgen cumule 25 ans
d’expérience dans la création musicale pour artistes, télévision, radio et spectacle vivant,
explorant de nombreux styles et formats.`,
  },
  en: {
    subtitle: "musician composer arranger",
    paragraph: `Pianist, composer, and studio producer, Ben Bridgen brings 25 years of experience
creating music for artists, television, radio, and live performance, exploring a wide range of
styles and formats.`,
  },
};

export default homeTexts;
